var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.509,
    height: 60.599,
    viewBox: "0 0 240.509 60.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-43 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(43 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M56.688,60.6H44.349l0-.01L38.175,47.4,28.342,26.379l-16,34.221H0l3.468-7.413,18.7-40L28.342,0h0l6.17,13.187,9.833,21.024L50.514,47.4l2.706,5.784Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M117.763,83.7H105.424l-3.468-7.413L99.25,70.5,93.08,57.312,99.25,44.12l6.17,13.192,3.011,6.441Z",
    transform: "translate(-48.736 -23.101)",
    fill: "#4cbb7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M79.519,112.687l0,.01H67.18l6.17-13.2Z",
    transform: "translate(-35.175 -52.097)",
    fill: "#4cbb7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    transform: "translate(131.082 47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M170.71,90.01,181.281,65.8h3.476l10.571,24.21h-4.158l-2.761-6.341H177.563l-2.728,6.341Zm12.276-18.826L179.1,80.116h7.777Z",
    transform: "translate(-170.71 -64.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M224.024,91.99a6.245,6.245,0,0,1-4.279-1.452,5.314,5.314,0,0,1-1.655-4.213V78.108H213.86V74.764h4.229V69.82h3.751v4.944h4.636v3.344H221.84v7.606q0,2.9,2.662,2.9a4.59,4.59,0,0,0,2.42-.616l1.127,3.135A9.13,9.13,0,0,1,224.024,91.99Zm14.013,0a6.245,6.245,0,0,1-4.279-1.452,5.3,5.3,0,0,1-1.655-4.213V78.108h-3.817V74.764H232.1V69.82h3.751v4.944h5.219v3.344h-5.219v7.606q0,2.9,2.662,2.9a4.815,4.815,0,0,0,2.42-.616l1.127,3.135A9.13,9.13,0,0,1,238.037,91.99Z",
    transform: "translate(-190.128 -66.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M276.459,95.931a8.867,8.867,0,1,1,0-17.731,7.88,7.88,0,0,1,8.222,8.453c0,.456-.011.863-.033,1.226h-13.4a4.68,4.68,0,0,0,1.6,3.36,5.873,5.873,0,0,0,8.525-1.314l2.865,2.046Q281.777,95.931,276.459,95.931Zm-5.049-10.78h9.482a4.32,4.32,0,0,0-1.584-2.777,4.688,4.688,0,0,0-2.986-1.006,5.264,5.264,0,0,0-3.151.99A4.4,4.4,0,0,0,271.41,85.152Z",
    transform: "translate(-214.295 -70.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M305.69,95.59V78.541h3.751V80.35a6.085,6.085,0,0,1,5.01-2.15,6.323,6.323,0,0,1,4.856,1.958,7.386,7.386,0,0,1,1.826,5.236v10.2h-3.751V86a4.9,4.9,0,0,0-.973-3.239,3.431,3.431,0,0,0-2.777-1.16,4.237,4.237,0,0,0-4.2,2.695V95.585H305.69Z",
    transform: "translate(-231.454 -70.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M348.394,91.99a6.245,6.245,0,0,1-4.279-1.452,5.314,5.314,0,0,1-1.655-4.213V78.108H338.23V74.764h4.229V69.82h3.751v4.944h5.219v3.344H346.21v7.606q0,2.9,2.662,2.9a4.59,4.59,0,0,0,2.42-.616l1.127,3.135A9.13,9.13,0,0,1,348.394,91.99Z",
    transform: "translate(-246.097 -66.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M370.546,69.2a2.389,2.389,0,0,1-1.754-.731,2.427,2.427,0,0,1-.731-1.787,2.5,2.5,0,0,1,2.486-2.486,2.419,2.419,0,0,1,1.787.731,2.389,2.389,0,0,1,.732,1.754,2.5,2.5,0,0,1-2.519,2.519ZM368.67,89.29V72.241h3.751V89.29Z",
    transform: "translate(-259.521 -64.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M388.535,95.869,380.83,78.82h4.158l5.181,11.968,5.219-11.968h4.2l-7.738,17.049Z",
    transform: "translate(-265.268 -70.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M425.629,95.931a8.867,8.867,0,1,1,0-17.731,7.88,7.88,0,0,1,8.222,8.453c0,.456-.011.863-.033,1.226h-13.4a4.68,4.68,0,0,0,1.6,3.36,5.873,5.873,0,0,0,8.525-1.314l2.865,2.046Q430.947,95.931,425.629,95.931Zm-5.049-10.78h9.482a4.32,4.32,0,0,0-1.584-2.777,4.688,4.688,0,0,0-2.986-1.006,5.264,5.264,0,0,0-3.151.99A4.395,4.395,0,0,0,420.58,85.152Z",
    transform: "translate(-281.424 -70.5)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.e534991912fa1117337cd8d93c2dfe9a.svg";
export { ForwardRef as ReactComponent };